export const APP_NAME = 'Greenroom'

/** Hard cap for one uploaded recording chunk. Recorders emit ~1 s slices, far below this. */
export const CHUNK_MAX_BYTES = 16 * 1024 * 1024
export const RECORDER_TIMESLICE_MS = 1000
/** Takes start this long after the producer presses record, so every recorder is already running. */
export const COUNTDOWN_MS = 3000
export const PCM_SAMPLE_RATE = 48000
export const MAX_DISPLAY_NAME = 60
export const MAX_MARKER_LABEL = 200
export const MAX_CHAT_MESSAGE = 2000
export const MAX_SCREEN_SHARES_PER_PARTICIPANT = 3

/** Background behind tiles in the editor preview and the rendered program. */
export const PROGRAM_BACKGROUND = '#0f1013'
export const PROGRAM_FPS = 30

export const DATA_TOPIC = {
  chat: 'greenroom.chat',
  marker: 'greenroom.marker',
  leaving: 'greenroom.leaving',
  status: 'greenroom.status',
  notice: 'greenroom.notice',
} as const

export const MARKER_COLORS = ['amber', 'teal', 'rose', 'violet', 'sky'] as const
export type MarkerColor = (typeof MARKER_COLORS)[number]
